import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { withFormik, FormikProps } from 'formik';
import { Grid, Box, CircularProgress, MenuItem } from '@material-ui/core';
import { translate } from 'helpers/intl';
import validationSchema from 'components/ChangeSecretQuestionModal/validationSchema';
import messages from 'components/ChangeSecretQuestionModal/messages';
import { OrangeButton } from 'components/Button';
import { ColoredDivider, StyledGrid } from 'components/MenuItem/styles';
import PasswordInputField from 'components/InputField/Password';
import { ShortBody } from 'components/Typography';
import { StyledForm } from 'components/ChangePassewordModal/styles';
import get from 'lodash/get';
import InputField from 'components/InputField';
import SelectInputField from 'components/SelectInputField';

const ChangeSecretQuestionForm = (
  props: {
    handleClose: Function;
    isLoading: boolean;
    questionsSecret: { label: string; value: string }[];
  } & FormikProps<FormValues>,
) => {
  const {
    values,
    touched,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
  } = props;
  return (
    <StyledForm onSubmit={handleSubmit}>
      <Box paddingX={2} pb={2}>
        <Grid container justify="center">
          <Grid item xs={12}>
            <Box mb={3}>
              <ShortBody weight="400">
                {translate(get(messages, 'selectQuestionTitle'), props)}
              </ShortBody>
              <SelectInputField
                name="secretQuestion"
                label={translate(get(messages, 'selectQuestion'), props)}
                onChange={handleChange}
                value={values.secretQuestion}
                data={props.questionsSecret}
                handleBlur={handleBlur}
                Children={[...props.questionsSecret].map((item: any) => (
                  <MenuItem value={item.value} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box mb={4}>
              <InputField
                name="response"
                label={translate(get(messages, 'reponse'), props)}
                placeholder={translate(get(messages, 'reponse'), props)}
                value={values.response}
                error={errors.response && touched.response}
                helperText={touched.response && errors.response}
                handleChange={handleChange}
                handleBlur={handleBlur}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <ShortBody weight="400">
              {translate(get(messages, 'confirmPassword'), props)}
            </ShortBody>
            <PasswordInputField
              label={translate(get(messages, 'password'), props)}
              name="password"
              placeholder={translate(get(messages, 'password'), props)}
              value={values.password}
              error={errors.password && touched.password}
              helperText={touched.password && errors.password}
              handleChange={handleChange}
              handleBlur={handleBlur}
            />
          </Grid>
        </Grid>
      </Box>
      <ColoredDivider orientation="horizontal" />
      <StyledGrid spacing={5} container justify="flex-end">
        <Grid item>
          <OrangeButton onClick={props.handleClose}>
            {translate(get(messages, 'cancel'), props)}
          </OrangeButton>
        </Grid>
        <Grid item>
          <OrangeButton
            type="submit"
            variant="contained"
            disabled={props.isLoading}
          >
            {translate(get(messages, 'valid'), props)}
            {props.isLoading ? (
              <CircularProgress
                color="inherit"
                size={20}
                style={{ marginLeft: '5px' }}
              />
            ) : null}
          </OrangeButton>
        </Grid>
      </StyledGrid>
    </StyledForm>
  );
};

export interface FormProps {
  intl: IntlShape;
  changeSecretQuestion: Function;
  handleClose: Function;
  isLoading: boolean;
  questionsSecret: { label: string; value: string }[];
}

interface FormValues {
  secretQuestion: string;
  response: string;
  password: string;
}

const Form = withFormik<FormProps, FormValues>({
  mapPropsToValues: () => {
    return {
      secretQuestion: '1',
      response: '',
      password: '',
    };
  },
  validationSchema,
  handleSubmit: (values, { props }) => {
    const dataToSend = {
      password: values.password,
      id_question: values.secretQuestion,
      questionResponse: values.response,
    };
    props.changeSecretQuestion(dataToSend);
    return props.handleClose();
  },
})(ChangeSecretQuestionForm);

export default injectIntl(Form);
